import React from 'react';
import { useTranslation } from 'react-i18next';
import GlobalStringSettingPage from './GlobalStringSettingPage';

interface GlobalProjectSettingsProjectDocumentPrefixProps {
  className?: string;
}

export const GlobalProjectSettingsProjectDocumentPrefix: React.FC<
  GlobalProjectSettingsProjectDocumentPrefixProps
> = (props) => {
  const { t } = useTranslation();
  return (
    <GlobalStringSettingPage
      className={props.className}
      settingType="projectDocumentPrefix"
      title={t('settings:projectSettingsTable.title.projectDocumentPrefix')}
    />
  );
};

export default GlobalProjectSettingsProjectDocumentPrefix;
